import Vue from 'vue';

import App from './App.vue';
import router from './router';
import './registerServiceWorker';

import { setDeferedInstallationPrompt } from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

// https://web.dev/customize-install/#listen_for_beforeinstallprompt
window.addEventListener('beforeinstallprompt', e => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later.
  setDeferedInstallationPrompt(e);
  // Update UI notify the user they can install the PWA
  // showInstallPromotion();
});

function getUserLocale() {
  const locale = window.navigator.language || window.navigator.userLanguage || i18n.locale;

  return {
    locale: locale,
    localeNoISO: locale.split('-')[0],
  };
}
let allowedLanguages = ['en', 'tr', 'es', 'fr'];

if (allowedLanguages.indexOf(getUserLocale().localeNoISO) <= 0) {
  i18n.locale = 'en';
} else {
  i18n.locale = getUserLocale().localeNoISO;
}
//Force language by url
var urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('lang')) {
  if (allowedLanguages.indexOf(urlParams.get('lang')) >= 0) {
    i18n.locale = urlParams.get('lang');
  }
}

new Vue({
  created() {
    // TODO: add a better routing intelligence
    if (process.env.NODE_ENV === 'production') this.$router.replace({ name: 'onboarding' });
  },

  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
